import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { getThousandComma } from "../../../../Api/ApiCommon";
import { useApi } from "../../../../hooks/useApi";
import LineBox from "../../../DefaultStyles/LineBox";
import { ISeries } from "../PayBoard/PayHistorySection";
import {
  AxixTitle,
  ChartContainer,
  DashBoardSectionTitle,
  DashBoardSectionTitleContainer,
  DashBoardViewDate,
  IndateSectionProps,
} from "./IndateSection";
import Chart from "react-apexcharts";
import DashBoardToggleBtn from "../DashBoardToggleBtn";
import useIsMobile from "../../../../hooks/useIsMobile";

interface ExitSectionProps extends IndateSectionProps {}

export default function ExitSection({ filter, setFilter }: ExitSectionProps) {
  const isMobile = useIsMobile();

  const { response } = useApi({
    method: "get",
    url:
      filter.startDate !== "" && filter.endDate !== ""
        ? `dash/total?type=user&subtype=exit&startdate=${dayjs(filter.startDate)
            .add(1, "day")
            ?.format("YYYY-MM-DD")}&enddate=${dayjs(filter.endDate)
            .add(1, "day")
            ?.format("YYYY-MM-DD")}&filter=day`
        : undefined,
  });

  const [series, setSeries] = useState<ISeries[]>([
    {
      name: "",
      data: [0, 0, 0, 0],
    },
  ]);
  const [date, setDate] = useState<string[]>([]);

  useEffect(() => {
    let series: any[] = [];
    let date: string[] = [];

    if (response?.status === 200) {
      for (let i = 0; i < response?.data.length; i++) {
        const element = response?.data[i];

        series.push(
          Number(
            (filter.isAccum ? element?.data?.total : element?.data?.count) ?? 0
          )
        );

        date.push(dayjs(element.date).add(-1, "day").format("M/DD (dd)"));
      }

      setSeries([
        {
          name: "탈퇴자",
          data: series.reverse(),
        },
      ]);
      setDate(date.reverse());
    }
  }, [response, filter]);

  return (
    <>
      <DashBoardSectionTitleContainer>
        <DashBoardSectionTitle>탈퇴자 추이</DashBoardSectionTitle>

        <DashBoardToggleBtn
          btnTextArray={["일별", "누적"]}
          filter={filter}
          setFilter={setFilter}
        />
      </DashBoardSectionTitleContainer>

      <LineBox boxPadding={"28px 32px"}>
        <DashBoardViewDate isMobile={isMobile}>
          조회 기간 : {filter.startDate} ~ {filter.endDate}
        </DashBoardViewDate>

        <ChartContainer>
          <AxixTitle>명</AxixTitle>

          <Chart
            type="line"
            height={300}
            series={series}
            options={{
              chart: {
                height: 350,
                type: "line",
                zoom: {
                  enabled: false,
                },
                toolbar: {
                  show: false,
                },
              },
              dataLabels: {
                enabled: true,
                offsetY: -5,
                style: {
                  fontWeight: 500,
                  colors: ["#ffffff"],
                },
                formatter: (val) => {
                  return getThousandComma(val);
                },
                background: {
                  dropShadow: {
                    enabled: false,
                  },
                  borderColor: "#ffffff",
                  foreColor: "#22222",
                  padding: 0,
                },
              },
              stroke: {
                curve: "smooth",
              },
              xaxis: {
                categories: date,
              },
              yaxis: {
                labels: {
                  formatter: (value) => {
                    return getThousandComma(value ?? 0);
                  },
                },
              },
              tooltip: {
                y: {
                  formatter: (value) => getThousandComma(value ?? 0) + "명",
                },
              },
            }}
          />

          <AxixTitle isX={true}>날짜</AxixTitle>
        </ChartContainer>
      </LineBox>
    </>
  );
}
